import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const StyledButton = styled.button`
  background: transparent;
  border: ${({ border }) => border || 'none'};
  position: absolute;
  transform-origin: center center;
  padding: ${({ padding }) => padding || 0};
  top: ${({ top }) => top || 0};
  left: ${({ left }) => left || 0};
  cursor: pointer;
  margin: 0;
`;

export const StyledView = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
`;

export const ImageButton = ({ className, accessibilityLabel, src, ...props }) => (
  <StyledButton className={className} aria-label={accessibilityLabel} {...props}>
    {src && <img src={src} width="100%" height="100%" alt="" />}
  </StyledButton>
);

ImageButton.propTypes = {
  className: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  src: PropTypes.string.isRequired,
};

ImageButton.defaultProps = {
  className: undefined,
  accessibilityLabel: 'Button',
};

export default {
  StyledButton,
  ImageButton,
};
